var chunkMapping = {
	"0": [
		4710,
		4258
	],
	"74": [
		5110
	],
	"152": [
		5188
	],
	"153": [
		5189
	],
	"156": [
		5192
	],
	"157": [
		5193
	],
	"158": [
		5194
	],
	"159": [
		5195
	],
	"160": [
		5196
	],
	"161": [
		5197
	],
	"162": [
		5198
	],
	"163": [
		5199
	],
	"164": [
		5200
	],
	"165": [
		5201
	],
	"166": [
		5202
	],
	"167": [
		5203
	],
	"168": [
		5204
	],
	"169": [
		5205
	],
	"170": [
		5206
	],
	"171": [
		5207
	],
	"172": [
		5208
	]
};
var idToExternalAndNameMapping = {
	"4258": [
		"default",
		"./nuorder-components",
		4110
	],
	"4710": [
		"default",
		"./Containers",
		3795
	],
	"5110": [
		"default",
		"./OrderlessInvoices",
		3795
	],
	"5188": [
		"default",
		"./AsyncEventTracker",
		3795
	],
	"5189": [
		"default",
		"./HostWrapper",
		3795
	],
	"5192": [
		"default",
		"./CheckoutV3",
		3795
	],
	"5193": [
		"default",
		"./CheckoutConfirmation",
		3795
	],
	"5194": [
		"default",
		"./ContactCreditCards",
		3795
	],
	"5195": [
		"default",
		"./AuditDialog",
		3795
	],
	"5196": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3795
	],
	"5197": [
		"default",
		"./InvoiceDialog",
		3795
	],
	"5198": [
		"default",
		"./PaymentDueModal",
		3795
	],
	"5199": [
		"default",
		"./PaymentModal",
		3795
	],
	"5200": [
		"default",
		"./PaymentHistory",
		3795
	],
	"5201": [
		"default",
		"./PaymentConfigurations",
		3795
	],
	"5202": [
		"default",
		"./PaymentPreferences",
		3795
	],
	"5203": [
		"default",
		"./ManagePaymentProcessing",
		3795
	],
	"5204": [
		"default",
		"./MobilePaymentsWrapper",
		3795
	],
	"5205": [
		"default",
		"./Challenge",
		3795
	],
	"5206": [
		"default",
		"./ManagePaymentMethods",
		3795
	],
	"5207": [
		"default",
		"./LightspeedReports",
		3795
	],
	"5208": [
		"default",
		"./ShippingPromotionsListContainer",
		3795
	]
};
var idToRemoteMap = {
	"4258": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 4110
		}
	],
	"4710": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5110": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5188": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5189": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5192": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5193": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5194": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5195": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5196": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5197": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5198": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5199": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5200": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5201": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5202": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5203": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5204": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5205": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5206": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5207": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	],
	"5208": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3795
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}